import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CompsTableHeader from '../comps_table_header';

import { changeSalePage, changeSaleSort } from '../store/actions/query';
import { retrieveSales } from '../store/actions/search';
import { setSaleColumns } from '../store/actions/session';

export class SalesTableHeader extends React.Component {
  static propTypes = {
    changePage: PropTypes.func.isRequired,
    changeSort: PropTypes.func.isRequired,
    retrieveSales: PropTypes.func.isRequired,
    setSaleColumns: PropTypes.func.isRequired,
    sort: PropTypes.string,
  };

  handleSortChange = (sortOption) => {
    const { changePage, changeSort, retrieveSales } = this.props;

    changeSort(sortOption);
    changePage(1);
    retrieveSales();
  }

  render() {
    const { sort } = this.props;
    return (
      <CompsTableHeader
        compType="sale"
        setColumns={this.props.setSaleColumns}
        sort={sort}
        onSortChange={this.handleSortChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  sort: state.query.saleSort
});

const mapDispatchToProps = {
  retrieveSales,
  setSaleColumns,

  changePage: changeSalePage,
  changeSort: changeSaleSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesTableHeader);
